/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
import React, { forwardRef, Ref } from "react";
import { getSvgResourceForSize, getDefaultSize } from "../../utils";
import { Icon, LodestarIconProps } from "../../icon";
import { SvgSyncLeft as SyncLeftMedium } from "./medium/SyncLeft";
const sizeMap = {
    medium: SyncLeftMedium,
};
const defaultSize = getDefaultSize(sizeMap);

export const SyncLeftIcon = forwardRef(
    (
        { size = defaultSize, ...rest }: LodestarIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon
            ref={ref}
            svgComponent={getSvgResourceForSize(sizeMap, size)}
            size={size}
            {...rest}
        />
    )
);
SyncLeftIcon.displayName = "SyncLeftIcon";
